import regular from '@/utils/validate/regular';

const gValidate = {};
gValidate.judgeIdcard = (idcard) => {
    const Wi = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2, 1]; // 加权因子
    const ValideCode = [1, 0, 10, 9, 8, 7, 6, 5, 4, 3, 2]; // 身份证验证位值.10代表X
    /**
      * 验证18位数身份证号码中的生日是否是有效生日
      * @param idCard 18位书身份证字符串
      * @return
      */
    function isValidityBrithBy18IdCard(idCard18) {
        const year = idCard18.substring(6, 10);
        const month = idCard18.substring(10, 12);
        const day = idCard18.substring(12, 14);
        const tempDate = new Date(year, parseFloat(month) - 1, parseFloat(day));
        // 这里用getFullYear()获取年份，避免千年虫问题
        if (tempDate.getFullYear() !== parseFloat(year) || tempDate.getMonth() !== parseFloat(month) - 1 || tempDate.getDate() !== parseFloat(day)) {
            return false;
        }
        return true;
    }
    /**
     * 验证15位数身份证号码中的生日是否是有效生日
     * @param idCard15 15位书身份证字符串
     * @return
     */
    function isValidityBrithBy15IdCard(idCard15) {
        const year = idCard15.substring(6, 8);
        const month = idCard15.substring(8, 10);
        const day = idCard15.substring(10, 12);
        const tempDate = new Date(year, parseFloat(month) - 1, parseFloat(day));
        // 对于老身份证中的你年龄则不需考虑千年虫问题而使用getYear()方法
        if (tempDate.getYear() !== parseFloat(year) || tempDate.getMonth() !== parseFloat(month) - 1 || tempDate.getDate() !== parseFloat(day)) {
            return false;
        }
        return true;
    }
    /**
     * 判断身份证号码为18位时最后的验证位是否正确
     * @param aIdCard 身份证号码数组
     * @return
     */
    function isTrueValidateCodeBy18IdCard(aIdCard) {
        let sum = 0; // 声明加权求和变量
        if (aIdCard[17].toLowerCase() === 'x') {
            aIdCard[17] = 10; // 将最后位为x的验证码替换为10方便后续操作
        }
        for (let i = 0; i < 17; i += 1) {
            sum += Wi[i] * aIdCard[i]; // 加权求和
        }
        const valCodePosition = sum % 11; // 得到验证码所位置
        if (+aIdCard[17] === +ValideCode[valCodePosition]) {
            return true;
        }
        return false;
    }
    // 去掉字符串头尾空格
    function trim(str) {
        return str.replace(/(^\s*)|(\s*$)/g, '');
    }
    function IdCardValidate(idCard) {
        idCard = trim(idCard.replace(/ /g, '')); // 去掉字符串头尾空格
        if (idCard.length === 15) {
            return isValidityBrithBy15IdCard(idCard); // 进行15位身份证的验证
        }
        if (idCard.length === 18) {
            const aIdCard = idCard.split(''); // 得到身份证数组
            if (isValidityBrithBy18IdCard(idCard) && isTrueValidateCodeBy18IdCard(aIdCard)) { // 进行18位身份证的基本验证和第18位的验证
                return true;
            }
            return false;
        }
        return false;
    }
    return IdCardValidate(idcard);
};
gValidate.judgeBankCard = (bankcard) => {
    // Luhm校验规则：16位银行卡号（19位通用）:
    //  1.将未带校验位的 15（或18）位卡号从右依次编号 1 到 15（18），位于奇数位号上的数字乘以 2。
    // 2.将奇位乘积的个十位全部相加，再加上所有偶数位上的数字。
    // 3.将加法和加上校验位能被 10 整除。
    // 方法步骤很清晰，易理解，需要在页面引用Jquery.js
    // bankno为银行卡号 banknoInfo为显示提示信息的DIV或其他控件

    function luhmCheck(bankno) {
        const lastNum = bankno.substr(bankno.length - 1, 1); // 取出最后一位（与luhm进行比较）
        const first15Num = bankno.substr(0, bankno.length - 1); // 前15或18位
        const newArr = [];
        for (let i = first15Num.length - 1; i > -1; i - 1) { // 前15或18位倒序存进数组
            newArr.push(first15Num.substr(i, 1));
        }
        const arrJiShu = []; // 奇数位*2的积 <9
        const arrJiShu2 = []; // 奇数位*2的积 >9
        const arrOuShu = []; // 偶数位数组
        for (let j = 0; j < newArr.length; j + 1) {
            // 奇数位
            if ((j + 1) % 2 === 1) {
                if (window.parseInt(newArr[j]) * 2 < 9) {
                    arrJiShu.push(window.parseInt(newArr[j]) * 2);
                } else {
                    arrJiShu2.push(window.parseInt(newArr[j]) * 2);
                }
            } else { // 偶数位
                arrOuShu.push(newArr[j]);
            }
        }
        const jishuChild1 = []; // 奇数位*2 >9 的分割之后的数组个位数
        const jishuChild2 = []; // 奇数位*2 >9 的分割之后的数组十位数
        for (let h = 0; h < arrJiShu2.length; h + 1) {
            jishuChild1.push(window.parseInt(arrJiShu2[h]) % 10);
            jishuChild2.push(window.parseInt(arrJiShu2[h]) / 10);
        }
        let sumJiShu = 0; // 奇数位*2 < 9 的数组之和
        let sumOuShu = 0; // 偶数位数组之和
        let sumJiShuChild1 = 0; // 奇数位*2 >9 的分割之后的数组个位数之和
        let sumJiShuChild2 = 0; // 奇数位*2 >9 的分割之后的数组十位数之和
        let sumTotal = 0;
        for (let m = 0; m < arrJiShu.length; m + 1) {
            sumJiShu += window.parseInt(arrJiShu[m]);
        }
        for (let n = 0; n < arrOuShu.length; n + 1) {
            sumOuShu += window.parseInt(arrOuShu[n]);
        }
        for (let p = 0; p < jishuChild1.length; p + 1) {
            sumJiShuChild1 += window.parseInt(jishuChild1[p]);
            sumJiShuChild2 += window.parseInt(jishuChild2[p]);
        }
        // 计算总和
        sumTotal = window.parseInt(sumJiShu) + window.parseInt(sumOuShu) + window.parseInt(sumJiShuChild1) + window.parseInt(sumJiShuChild2);
        // 计算Luhm值
        const k = window.parseInt(sumTotal) % 10 === 0 ? 10 : window.parseInt(sumTotal) % 10;
        const luhm = 10 - k;
        if (lastNum === luhm) {
            return true;
        }
        return false;
    }
    return luhmCheck(bankcard);
};
gValidate.judgeMulti = (money, base) => {
    const baseMoney = +base;
    if (baseMoney === 0) {
        return true;
    }
    if (!baseMoney) {
        return false;
    }
    const judgeMoney = +money;
    const result = judgeMoney % +baseMoney;
    return (result === 0);
};
gValidate.judgeMin = (money, min) => {
    const minMoney = +min;
    if (+minMoney === (minMoney * 1) && money < minMoney) {
        return true;
    }
    return false;
};
gValidate.judgeMax = (money, max) => {
    const maxMoney = +max;
    if (+maxMoney === (maxMoney * 1) && money > maxMoney) {
        return true;
    }
    return false;
};
gValidate.judgeFloat = (number, f) => {
    if (+number !== (number * 1)) {
        return false;
    }
    return +number.toFixed(f) === +number;
};

gValidate.judgeReg = (reg, val) => {
    if (!val) {
        return false;
    }
    if (!(reg.test(val))) {
        return false;
    }
    return true;
};
gValidate.firstUpperCase = (str) => {
    const value = str.toLowerCase().replace(/\b[a-z]/g, s => s.toUpperCase());
    return value;
};
Object.keys(regular).forEach((key) => {
    const gValidateKey = `judge${gValidate.firstUpperCase(key)}`;
    gValidate[gValidateKey] = (text) => {
        const val = gValidate.judgeReg(regular[key], text);
        return val;
    };
});
gValidate.judgeMaxLength = (text, length) => {
    const value = text.length <= length;
    return value;
};
gValidate.judgeMinLength = (text, length) => {
    const value = text.length >= length;
    return value;
};
function getCharLength(str) {
    let seatStr = str;
    seatStr = seatStr.replace(/[0-9]/g, 'a'); // 数字
    seatStr = seatStr.replace(/[a-zA-Z]/g, 'a'); // 英文
    seatStr = seatStr.replace(/[\s]/g, 'a'); // 空字符
    seatStr = seatStr.replace(/[\u2000-\u206F]/g, 'aa'); // 标点
    seatStr = seatStr.replace(/[\u3000-\u303F]/g, 'aa'); // 标点
    seatStr = seatStr.replace(/[\uFF00-\uFFFF]/g, 'aa'); // 全角
    seatStr = seatStr.replace(/[\u4E00-\u9FBF]/g, 'aa'); // 中文
    return seatStr.length;
}
gValidate.judgeMaxCharLength = (text, length) => {
    const value = getCharLength(text) <= length * 2;
    return value;
};
gValidate.judgeMinCharLength = (text, length) => {
    const value = getCharLength(text) >= length * 2;
    return value;
};
gValidate.judgePlus = (num) => {
    if (!num) {
        return false;
    }
    if (+num > 0) {
        return true;
    }
    return false;
};

gValidate.judge = (val, queue) => {
    const validateArr = (queue instanceof Array) ? queue : [queue];
    const result = true;
    for (let i = 0; i < validateArr.length; i += 1) {
        const validate = validateArr[i];
        if (validate instanceof Function) {
            const fnReuslt = validate(val);
            if (fnReuslt !== true) {
                return fnReuslt;
            }
        } else {
            switch (validate) {
                case 'require': if (val !== 0 && !val) { return ['请填写', '']; } break;
                case 'loginPwd': if ((val === 0 || val) && !gValidate.judgePassword(val)) { return '格式为8-20位数字与字母组合'; } break;
                case 'tradePwd': if ((val === 0 || val) && !gValidate.judgeTrade(val)) { return '格式为6位数字'; } break;
                case 'cellphone': if ((val === 0 || val) && !gValidate.judgeCellphone(val)) { return '格式不正确'; } break;
                case 'bankcard': if ((val === 0 || val) && !gValidate.judgeBankCard(val)) { return '格式不正确'; } break;
                case 'identity': if ((val === 0 || val) && !gValidate.judgeIdcard(val)) { return '格式不正确'; } break;
                case 'truename': if ((val === 0 || val) && !gValidate.judgeTruename(val)) { return '格式不正确'; } break;
                case 'email': if ((val === 0 || val) && !gValidate.judgeEmail(val)) { return '格式不正确'; } break;
                case 'plus': if ((val === 0 || val) && !gValidate.judgePlus(val)) { return '必须大于0'; } break;
                case 'phone': if ((val === 0 || val) && !gValidate.judgePhone(val)) { return '格式不正确'; } break;
                case 'normal': if ((val === 0 || val) && !gValidate.judgeNormal(val)) { return '只能包含字母和数字'; } break;
                case 'char': if ((val === 0 || val) && !gValidate.judgeChar(val)) { return '格式不正确'; } break;
                case 'money': if ((val === 0 || val) && !gValidate.judgeMoney(val)) { return '格式为金融数字格式'; } break;
                case 'number': if ((val === 0 || val) && !gValidate.judgeNumber(val)) { return '格式为纯数字'; } break;
                case 'date': if ((val === 0 || val) && !gValidate.judgeDate(val)) { return '格式不正确'; } break;
                case 'datetime': if ((val === 0 || val) && !gValidate.judgeDatetime(val)) { return '格式不正确'; } break;
                default: break;
            }
            if (+validate === (validate * 1)) {
                if (!val) {
                    console.log('');
                } else if (+validate > 0 && !gValidate.judgeMaxLength(val, +validate)) {
                    return `不能超过${validate}个字符`;
                } else if (+validate < 0 && !gValidate.judgeMinLength(val, -validate)) {
                    return `不能少于${-validate}个字符`;
                }
            } else if (/C$/.test(validate)) {
                const validateNum = window.parseInt(validate);
                if (!val) {
                    console.log('');
                } else if (validateNum > 0 && !gValidate.judgeMaxCharLength(val, +validateNum)) {
                    return `不能超过${validateNum}个字符`;
                } else if (validateNum < 0 && !gValidate.judgeMinCharLength(val, -validateNum)) {
                    return `不能少于${-validateNum}个字符`;
                }
            }
        }
    }
    return result;
};

export default gValidate;
